import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';

export interface LegacyCollar extends BaseEntity {
  name: string;
  isLegacyOrphrey: boolean | null;
  isLegacyPlain: boolean | null;
  isAlb: boolean | null;
  sortOrder?: number;
}

export interface CreateLegacyCollarData {
  name: string;
}

export type UpdateLegacyCollarData = Partial<CreateLegacyCollarData>;

const legacyCollarApi = createCrudApi<
  LegacyCollar,
  CreateLegacyCollarData,
  UpdateLegacyCollarData
>('legacy-collar');

export const getAllLegacyCollars = legacyCollarApi.getAll;
export const getLegacyCollarById = legacyCollarApi.getById;
export const createLegacyCollar = legacyCollarApi.create;
export const updateLegacyCollar = legacyCollarApi.update;
export const deleteLegacyCollar = legacyCollarApi.delete;
export const reorderLegacyCollars = legacyCollarApi.reorder;
